import React, { useState } from "react";
import Lightbox from "react-awesome-lightbox";
import "react-awesome-lightbox/build/style.css";

export function LogoShowcase() {
  const logos = [
    { src: "/Logo%20on%20Card%20Mockup.png", alt: "Logo on card mockup" },
    { src: "/Primary%20Logo-01.png", alt: "Primary logo" },
    { src: "/Palm_Sucess.png", alt: "Palm Success brand" },
    { src: "/Ebenzer.png", alt: "Ebenzer Drafting and Construction" },
    { src: "/Romana_main.png", alt: "ROMANA premium olive oil" },
    { src: "/Romonia.png", alt: "ROMANA brand visual" },
    { src: "/Auroa.jpg", alt: "Aurora Collection wordmark" },
    { src: "/Shelmur.png", alt: "Shelmur Car Rentals web design" },
    { src: "/image.png", alt: "SheetBills product" },
  ];

  const [lightboxIndex, setLightboxIndex] = useState(null);

  return (
    <section className="py-12 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">Our Logo Portfolio</h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Click an image to view it in full-screen.
          </p>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
          {logos.map((logo, index) => (
            <img 
              key={index} 
              src={logo.src} 
              alt={logo.alt} 
              className="cursor-pointer rounded-md hover:shadow-lg transition-all"
              onClick={() => setLightboxIndex(index)}
            />
          ))}
        </div>
      </div>
      {lightboxIndex !== null && (
        <Lightbox 
          images={logos.map((logo) => ({ url: logo.src, title: logo.alt }))}
          startIndex={lightboxIndex}
          onClose={() => setLightboxIndex(null)}
        />
      )}
    </section>
  );
}
